import React, { useState } from 'react';
import { Modal, Input, message, Button, Form } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import useInstructorCreate from '../../gql/hooks/useInstructorCreate';
import { validateEmail } from '../../utils';
import './styles.less';

const ILTInstructorAddModal = ( { addedCallback } ) => {
    const [ addForm ] = Form.useForm();
    const { createInstructor } = useInstructorCreate();
    const [ showAddModal, setShowAddModal ] = useState( false );
    const [ modalIsSaving, setModalIsSaving ] = useState( false );
 
    const handleAddClick = () => {
        setShowAddModal( true );
    };

    const handleAddClose = () => {
        addForm.submit();
    };
    
    const handleAddCancel = () => {
        setShowAddModal( false );
        addForm.resetFields();
    };

    /*************************************
     *  ANCHOR Add Instructor
     *************************************/
 
    const handleAddInstructorSubmit = async ( values ) => {
        setModalIsSaving( true );
       
        const input = { 
            name: values.instructorName || '',
            title: values.instructorTitle || '',
            description: values.instructorDescription || '',
            emailAddress: values.instructorEmailAddress || '' 
        };
 
        const response = await createInstructor( input );

        if ( response.success ) { 
            addedCallback(  {   
                ...response.response.data.createInstructor,
                key: response.response.data.createInstructor.id 
            } );
        } else {
            message.error( 'Error creating instuctor. Please try again later.' );
        }
        
        addForm.resetFields();
        setModalIsSaving( false );
        setShowAddModal( false );
    };
    
    return (
        <>
            <Button   
                style={ { marginTop: '4px' } }
                type="text"
                icon={ <PlusOutlined /> }
                onClick= { () => handleAddClick() }
            />

            { showAddModal && 
                <Modal
                    centered
                    width={ 800 }
                    title="Add Instructor"
                    open={ showAddModal }
                    onOk={ handleAddClose }
                    onCancel={ handleAddCancel } 
                    confirmLoading={ modalIsSaving }
                >
                    <Form
                        form={ addForm }
                        name="add-form"
                        layout="vertical"
                        onFinish={ handleAddInstructorSubmit }
                        scrollToFirstError
                        disabled={ modalIsSaving }
                        initialValues={ 
                            { 
                                instructorName: '',
                                instructorTitle: '',
                                instructorDescription: '',
                                instructorEmailAddress: ''
                            }
                        }
                    >   
                        <Form.Item
                            name="instructorName"
                            label="Name"
                            rules={ [
                                {
                                    required: true,
                                    validateTrigger: [],
                                    message: 'Name is required',
                                },
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'Name must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="instructorTitle"
                            label="Title"
                            rules={ [
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'Name must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="instructorDescription"
                            label="Description"
                            rules={ [
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'Name must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="instructorEmailAddress"
                            label="Email"
                            rules={ [
                                {
                                    max: 200,
                                    validateTrigger: [],
                                    message: 'Email must be less than 200 characters long.',
                                },
                                {
                                    message: 'Must be a valid email address',
                                    validateTrigger: [],
                                    validator: ( _, value ) => {
                                        if ( !value ) {
                                            return Promise.resolve();
                                        }
                                        
                                        if ( validateEmail( value ) ) {
                                            return Promise.resolve();
                                        } else {
                                            return Promise.reject();
                                        }
                                    }
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>
                    </Form>
                </Modal>
            }
        </>
    );
};

export default ILTInstructorAddModal;
